import styled from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  label {
    margin-bottom: 4px;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
    font-size: 13px;
    line-height: 23px;
    /* identical to box height, or 177% */

    letter-spacing: 0.12em;
    text-transform: uppercase;

    color: #6c6c6c;

    span {
      letter-spacing: normal;
      text-transform: capitalize;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
    }
  }

  textarea {
    padding: 10px;
    border: 1px solid #d8d8d8;

    &::placeholder {
      color: #d8d8d8;
    }
  }

  input {
    padding: 16px;
    height: 56px;
    border: 1px solid #d8d8d8;
    border-radius: 0;

    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;

    &::placeholder {
      color: #d8d8d8 !important;
    }
  }

  @media (max-width: 992px) {
    input {
      width: 100%;
    }
  }
`;

export const StyledCheckbox = styled.label`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;

  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    border: 1px solid #d8d8d8;
    position: absolute;
    top: 1px;
    left: 0;
    height: 20px;
    width: 20px;
    background: white;
    border-radius: 2px;
  }

  &:hover input ~ span {
    /* Hover Color */
    background-color: white;
  }

  input:checked ~ span {
    border: 1px solid #2a5caf;
    background-color: ${({ theme }) => theme.colors.limoncello};
  }

  span:after {
    content: '';
    position: absolute;
    display: none;
  }

  input:checked ~ span:after {
    display: block;
  }

  span:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #2a5caf;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const StarStyles = styled.div`
  pointer-events: none !important;
  cursor: default;
  .rc-rate-star:hover,
  .rc-rate-star-half:hover .rc-rate-star-first:hover,
  .rc-rate-star-full:hover .rc-rate-star-second:hover {
    color: #ebba4f;
  }

  .rc-star:focus {
    outline: none;
  }
  .rc-rate {
    margin: 0;
    padding: 0;
    list-style: none;
    display: inline-block;
    vertical-align: middle;
    font-weight: normal;
    font-style: normal;
    outline: none;

    li {
      margin-right: 4px;
    }
  }
  .rc-rate-disabled .rc-rate-star:before,
  .rc-rate-disabled .rc-rate-star-content:before {
    cursor: default;
  }
  .rc-rate-disabled .rc-rate-star:hover {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  .rc-rate-star {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-right: 1px;
    position: relative;
    transition: all 0.3s;
    color: white;
    line-height: 1;
  }
  .rc-rate-star-first,
  .rc-rate-star-second {
    transition: all 0.3s;
  }
  .rc-rate-star-focused,
  .rc-rate-star:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .rc-rate-star-first {
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
  }
  .rc-rate-star-half .rc-rate-star-first,
  .rc-rate-star-half .rc-rate-star-second {
    opacity: 1;
  }
  .rc-rate-star-half .rc-rate-star-first,
  .rc-rate-star-full .rc-rate-star-second {
    color: #ebba4f !important;
  }
  .rc-rate-star-half:hover .rc-rate-star-first,
  .rc-rate-star-full:hover .rc-rate-star-second {
    color: #ebba4f !important;
  }
  @font-face {
    font-family: 'anticon';
    src: url('//at.alicdn.com/t/font_r5u29ls31bgldi.eot');
    /* IE9*/
    src: url('//at.alicdn.com/t/font_r5u29ls31bgldi.eot?#iefix')
        format('embedded-opentype'),
      /* IE6-IE8 */ url('//at.alicdn.com/t/font_r5u29ls31bgldi.woff')
        format('woff'),
      /* chrome、firefox */ url('//at.alicdn.com/t/font_r5u29ls31bgldi.ttf')
        format('truetype'),
      /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
        url('//at.alicdn.com/t/font_r5u29ls31bgldi.svg#iconfont') format('svg');
    /* iOS 4.1- */
  }
  .anticon {
    font-style: normal;
    vertical-align: baseline;
    text-align: center;
    text-transform: none;
    line-height: 1;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .anticon:before {
    display: block;
    font-family: 'anticon' !important;
  }
  .anticon-star:before {
    content: '\e660';
  }
`;

export const StarStylesForm = styled.div`
  .rc-rate-star-half:hover .rc-rate-star-first:hover,
  .rc-rate-star-full:hover .rc-rate-star-second:hover {
    color: #ebba4f;
  }

  .rc-star:focus {
    outline: none;
  }
  .rc-rate {
    padding: 0;
    list-style: none;
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    font-weight: normal;
    font-style: normal;
    outline: none;

    li {
      margin-right: 4px;
    }
  }
  .rc-rate-disabled .rc-rate-star:before,
  .rc-rate-disabled .rc-rate-star-content:before {
    cursor: default;
  }
  .rc-rate-disabled .rc-rate-star:hover {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  .rc-rate-star {
    margin-top: 8px;
    padding: 0;
    display: inline-block;
    margin-right: 1px;
    position: relative;
    transition: all 0.3s;
    color: white;
    cursor: pointer;
    line-height: 1.5;
  }
  .rc-rate-star-first,
  .rc-rate-star-second {
    transition: all 0.3s;
  }
  .rc-rate-star-focused,
  .rc-rate-star:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .rc-rate-star-first {
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
  }
  .rc-rate-star-half .rc-rate-star-first,
  .rc-rate-star-half .rc-rate-star-second {
    opacity: 1;
  }
  .rc-rate-star-half .rc-rate-star-first,
  .rc-rate-star-full .rc-rate-star-second {
    color: #ebba4f;
  }
  .rc-rate-star-half:hover .rc-rate-star-first,
  .rc-rate-star-full:hover .rc-rate-star-second {
    color: #ebba4f;
  }
  @font-face {
    font-family: 'anticon';
    src: url('//at.alicdn.com/t/font_r5u29ls31bgldi.eot');
    /* IE9*/
    src: url('//at.alicdn.com/t/font_r5u29ls31bgldi.eot?#iefix')
        format('embedded-opentype'),
      /* IE6-IE8 */ url('//at.alicdn.com/t/font_r5u29ls31bgldi.woff')
        format('woff'),
      /* chrome、firefox */ url('//at.alicdn.com/t/font_r5u29ls31bgldi.ttf')
        format('truetype'),
      /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
        url('//at.alicdn.com/t/font_r5u29ls31bgldi.svg#iconfont') format('svg');
    /* iOS 4.1- */
  }
  .anticon {
    font-style: normal;
    vertical-align: baseline;
    text-align: center;
    text-transform: none;
    line-height: 1;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .anticon:before {
    display: block;
    font-family: 'anticon' !important;
  }
  .anticon-star:before {
    content: '\e660';
  }
`;
